import { Navigate, Route, Routes } from "react-router-dom";

import AdminLayout from "@/layouts/AdminLayout";
import Authors from "@/pages/Authors";
import BrandVoice from "@/pages/BrandVoice";
import ChatPlayground from "@/pages/ChatPlayground";
import ContentLibrary from "@/pages/ContentLibrary";
import ContentTemplateEditor from "@/pages/ContentTemplateEditor";
import ContentTemplates from "@/pages/ContentTemplates";
import ContentTestRun from "@/pages/ContentTestRun";
import Dashboard from "@/pages/Dashboard";
import GenerationLogs from "@/pages/GenerationLogs";
import HelpCenter from "@/pages/HelpCenter";
import MediaLibrary from "@/pages/MediaLibrary";
import SettingsModels from "@/pages/SettingsModels";
import SettingsPrompt from "@/pages/SettingsPrompt";
import SettingsWidget from "@/pages/SettingsWidget";
import Newsroom from "@/pages/Newsroom";
import SettingsTools from "@/pages/SettingsTools";
import UsersManagement from "@/pages/UsersManagement";
import RolesManagement from "@/pages/RolesManagement";
import Conversations from "@/pages/Conversations";
import AiCost from "@/pages/AiCost";
import AuditLogs from "@/pages/AuditLogs";
import CompHealth from "@/pages/CompHealth";

const App = () => {
  return (
    <Routes>
      <Route element={<AdminLayout />}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/widget" element={<SettingsWidget />} />
        <Route path="/content" element={<ContentLibrary />} />
        <Route path="/help" element={<HelpCenter />} />
        <Route path="/news" element={<Newsroom />} />
        <Route path="/authors" element={<Authors />} />
        <Route path="/media" element={<MediaLibrary />} />
        <Route path="/models" element={<SettingsModels />} />
        <Route path="/prompt" element={<SettingsPrompt />} />
        <Route path="/tools" element={<SettingsTools />} />
        <Route path="/playground" element={<ChatPlayground />} />
        <Route path="/users" element={<UsersManagement />} />
        <Route path="/roles" element={<RolesManagement />} />
        <Route path="/conversations" element={<Conversations />} />
        <Route path="/ai-cost" element={<AiCost />} />
        <Route path="/audit-logs" element={<AuditLogs />} />
        <Route path="/comp-health" element={<CompHealth />} />
        <Route path="/content-templates" element={<ContentTemplates />} />
        <Route path="/content-templates/new" element={<ContentTemplateEditor />} />
        <Route path="/content-templates/:id" element={<ContentTemplateEditor />} />
        <Route path="/content-test" element={<ContentTestRun />} />
        <Route path="/generation-logs" element={<GenerationLogs />} />
        <Route path="/brand-voice" element={<BrandVoice />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
};


export default App;
